const ShoppingRouter = [
  {
    path: '/shopping/step1',
    name: 'Step1',
    component: () => import('../../views/Shopping/Step1.vue'),
    meta: {
      title: 'route.title.shoppingCart', // 購物車
      layout: 'mainframe',
      shopping: true,
      haveTitle: true, // 標題
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/shopping/step2/:orderId?',
    name: 'Step2',
    component: () => import('../../views/Shopping/Step2.vue'),
    meta: {
      title: 'route.title.fillOrderData', // 填寫訂購資料
      layout: 'mainframe',
      shopping: true,
      haveTitle: true, // 標題
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/shopping/step3/:orderId?',
    name: 'Step3',
    component: () => import('../../views/Shopping/Step3.vue'),
    meta: {
      title: 'route.title.confirmCheckout', // 確定結帳
      layout: 'mainframe',
      shopping: true,
      haveTitle: true, // 標題
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/shopping/finish',
    name: 'Finish',
    component: () => import('../../views/Shopping/Finish.vue'),
    meta: {
      title: 'route.title.orderComplete', // 完成訂單
      layout: 'mainframe',
      haveTitle: true, // 標題
      shopping: true,
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/shopping/failed',
    name: 'OrderPayFailed',
    component: () => import('../../views/Shopping/Failed.vue'),
    meta: {
      title: 'route.title.orderFailed', // 訂單失敗
      layout: 'mainframe',
      haveTitle: true, // 標題
      shopping: true,
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
];

export default ShoppingRouter;
